import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/ui/Button';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0b0f19',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="h1" sx={{ fontFamily: 'Space Grotesk', color: '#0066ff', fontSize: '6rem' }}>
          404
        </Typography>
        <Typography variant="h4" sx={{ color: '#ffffff', fontFamily: 'Space Grotesk', mb: 2 }}>
          Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ color: '#c2c6d8', mb: 4 }}>
          The page you are looking for does not exist or has been relocated.
        </Typography>
        <Button variant="contained" glow onClick={() => navigate('/')}>
          Return to Homepage
        </Button>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
